import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  /** Icon element to display above the title. */
  icon?: ReactNode;
  /** Main title text. */
  title: string;
  /** Descriptive text below the title. */
  description?: string;
  /** Optional action button or element. */
  action?: ReactNode;
}

/**
 * Reusable empty state component for pages and sections with no data.
 *
 * Displays a centered layout with an icon, title, description,
 * and optional action button. Uses muted colors for a subtle appearance.
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className={styles.container} role="status">
      {icon && (
        <div className={styles.iconWrapper} aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className={styles.title}>{title}</h3>
      {description && (
        <p className={styles.description}>{description}</p>
      )}
      {action && (
        <div className={styles.action}>{action}</div>
      )}
    </div>
  );
}
